// Utils
import { insertAtIndex } from '../insertAtIndex';
/**
 * Insert a value after a specific value. If the value to insert after is not found
 * then the value to insert is added to the end of the array
 *
 * @template T
 * @param {T[]} arrayToInsertInto The array to contain the new value
 * @param {T}valueToInsert The value we want to insert
 * @param {T}valueToInsertAfter The value that dictates the position of the new value
 *
 * @returns {T[]} Array of values with the newly inserted value
 */
export function insertAfterValue(arrayToInsertInto, valueToInsert, valueToInsertAfter) {
    var position = arrayToInsertInto.indexOf(valueToInsertAfter);
    position = position !== -1 ? position : arrayToInsertInto.length;
    return insertAtIndex(arrayToInsertInto, valueToInsert, position + 1);
}
//# sourceMappingURL=insertAfterValue.js.map